// components/WebSocketStatus.jsx
import React from 'react';
import './WebSocketStatus.css';

function WebSocketStatus({ connected, reconnecting, error, lastCloseCode, isAppActive = true }) {

     if (!isAppActive) return null;
    // ✅ Если соединение есть - не показываем
    if (connected) return null;
    
    // ✅ Если код закрытия 1000 - не показываем (это нормальное закрытие)
    if (lastCloseCode === 1000) return null;
    
    // ✅ Если нет ошибки и нет переподключения - не показываем
    if (!error && !reconnecting) return null;
    
    return (
        <div className={`ws-status ${reconnecting ? 'reconnecting' : 'disconnected'}`}>
            <div className="ws-status-content">
                 {reconnecting && (
                    <span className="ws-status-spinner">
                        <div className="spinner"></div>
                    </span>
                )}
                <span className="ws-status-text">
                    {reconnecting 
                        ? 'Cоединение... '
                        : error || 'НЕТ Соединения'
                    }
                </span>
               
            </div>
        </div>
    );
}

export default WebSocketStatus;